import React from 'react';
import { orderBy } from 'lodash';
import { Link } from 'react-router-dom';
import { Progress, Tooltip } from 'antd';
import { getAlertColorCode } from '../../../../util/miscellaneousUtils';
import AlertLevels from '../../../../components/ns/AlertLevels';
import {
  convertISOToDateFormat,
  convertISOToDateTimeFormat
} from '../../../../util/timezone';

import style from './index.scss';

const getColumnRender = (column, record, alertIdClickHandler) => {
  switch (column.itemName) {
    case 'hitsSummary':
      return <AlertLevels data={record.hitsSummary} />;
    case 'alertScore':
      return (
        <div className={style.flex} key={record.alertId}>
          <Tooltip title={record[column.itemName]}>
            <p className={style.alertScore}>
              {record[column.itemName]?.toFixed(2)?.toString()}
            </p>
          </Tooltip>
          <Progress
            percent={record.alertScore}
            strokeColor={getAlertColorCode(record.alertLevel)}
            showInfo={false}
          />
        </div>
      );
    case 'alertId':
      return (
        <p
          className={style.tableLink}
          onClick={() => alertIdClickHandler(record[column.itemName])}>
          {record[column.itemName]}
        </p>
      );
    case 'alertDate':
      return <p>{convertISOToDateFormat(record[column.itemName])}</p>;
    case 'txnDateTime':
      return <p>{convertISOToDateTimeFormat(record[column.itemName])}</p>;
    case 'reviewStatus':
      return (
        <div
          className={style.reviewStatus}
          style={{
            color: record.reviewStatus === 'Completed' ? '#71C969' : '#748aa1'
          }}>
          {record[column.itemName] ? record[column.itemName] : '--'}
        </div>
      );
    case 'reviewFeedback':
      if (record[column.itemName])
        return (
          <div
            className={style.reviewFeedbackBadge}
            style={{ background: getAlertColorCode(record.reviewFeedback) }}>
            {record[column.itemName]}
          </div>
        );
      else return <div>--</div>;
    case 'primaryPartyName':
      return (
        <p>
          {record[column.itemName]}
          {record.isWhitelisted && (
            <Tooltip
              placement="right"
              overlayClassName={style.whiteList_tooltip}
              title={'Whitelisted'}>
              <i
                className="fa fa-flag-o"
                aria-hidden="true"
                style={{ fontSize: '12px', padding: '4px' }}></i>
            </Tooltip>
          )}
        </p>
      );
  }
  return null;
};

export const parseColumnsForRunInstanceResultListing = (
  settings,
  alertIdClickHandler
) => {
  let columns = null;
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']).filter(
      (column) => column.columnVisibility
    );
    columns = sortedSettings.map((setting) => {
      return {
        title: (
          <div className={style.tableHeader}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => (
                <p key={idx} className={style.strong}>
                  {column.itemLabel}
                </p>
              ))}
          </div>
        ),
        width: orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
          .filter((column) => column.visibility)
          .map((column, idx) =>
            column.itemName === 'hitsSummary'
              ? '200px'
              : column.itemName === 'txnDateTime' ||
                column.itemName === 'transactionKey'
              ? '180px'
              : null
          ),
        render: (text, record) => (
          <div className={style.tableContent}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (
                  getColumnRender(column, record, alertIdClickHandler) !== null
                )
                  return getColumnRender(column, record, alertIdClickHandler);
                else if (setting.columnDetail.length >= 2)
                  return (
                    <p key={record.alertId + idx} className={style.mutliRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
                else
                  return (
                    <p
                      key={record.alertId + idx}
                      className={style.singleRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
              })}
          </div>
        )
      };
    });
  }
  return columns;
};
